import { render, staticRenderFns } from "./statusSelector.vue?vue&type=template&id=8964d7de&scoped=true&"
import script from "./statusSelector.vue?vue&type=script&lang=js&"
export * from "./statusSelector.vue?vue&type=script&lang=js&"
import style0 from "./statusSelector.vue?vue&type=style&index=0&id=8964d7de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964d7de",
  null
  
)

export default component.exports